/**
 * 칸 비율 = Figma 1380(DD-19) 의 칸 너비(합 1380). 표는 부모 폭을 채우고 칸은 이 비율로 나눈다(DD-15 H2).
 * Figma 는 앞 5칸이 최소 폭 그대로, 뒤 4칸이 남는 폭을 똑같이(110.75) 나눈다. 1320 때는 [219, 306, 121, 121, 170, 110, 79, 97, 97].
 * 기존 코드 값은 [180, 250, 100, 100, 140, 90, 60, 80, 80]
 */
export const FUND_ROW_WIDTHS: readonly number[] = [
  219, 306, 121, 121, 170, 110.75, 110.75, 110.75, 110.75,
];

/**
 * status=init 막대 폭(px, 칸 순서대로) — Figma S04 로딩(`2143:22449`)의 칸별 막대 폭 그대로(Figma 막대는 칸 폭과 상관없이 고정, DD-19).
 * 표 칸 너비와 같은 표마다의 명세라 여기에 둔다(raw 예외, R4). 칸이 좁으면 칸 폭에 맞춘다
 */
export const FUND_ROW_SKELETON_PX: readonly number[] = [160, 227, 83, 83, 122, 74, 46, 65, 65];

/** 표 최소 폭(Figma 칸 최소 폭의 합 ≒ 1320). 부모가 이보다 좁으면 표를 감싼 틀이 가로 스크롤한다 */
export const FUND_ROW_MIN_WIDTH_PX = 1314;

/** 칸 너비 비율 → `<th>` · `<td>` 의 % 너비(table-fixed 에서 쓴다) */
export const fundRowCellWidth = (widths: readonly number[], index: number) => {
  const total = widths.reduce((sum, width) => sum + width, 0);
  return `${(((widths[index] ?? 0) / total) * 100).toFixed(4)}%`;
};

/** 칸: 좌우 여백 8, 줄 아래 2px canvas 선. 글자 · 위아래 여백은 _Table/Row density=default(머리 44 · 본문 54) */
export const FUND_ROW_CELL_CLASS = {
  header:
    'border-b-2 border-bg-canvas px-2 pt-3 pb-2-5 text-left align-middle text-fg-default typo-label',
  row: 'border-b-2 border-bg-canvas px-2 py-4 text-left align-middle text-fg-default typo-body-sm',
} as const;

/**
 * 줄: 흰 면. 본문 줄은 누를 수 있다. 올리거나 키보드 포커스하면 칸 면이 모두 표 hover 면(DD-26 6 —
 * 칸마다 `TABLE_HOVER_CELL_CLASS.row`, 줄에 `data-hover-row`)
 */
export const FUND_ROW_CLASS = {
  header: 'bg-bg-surface',
  row: 'cursor-pointer bg-bg-surface focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-border-focus',
} as const;
